const data = {
  id: 'b40dc66f-a441-4322-9c60-72f6df0f74fb',
  title: 'Find three words in the puzzle using given pictures',
  subTitle: 'Tìm từ dựa vào các bức tranh cho sẵn',
  type: 'PuzzleWords',
  question: null,
  imageUrl: null,
  audioUrl: null,
  answers: [
    {
      answer: 'cup',
      imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Movers/cup.png',
    },
    {
      answer: 'book',
      imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/book.png',
    },
    {
      answer: 'car',
      imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/car.png',
    },
  ],
  settings: {
    question: {
      rows: 5,
      columns: 5,
    },
  },
};
export default data;
